const React = require('react');
const { default: Styled } = require('styled-components');
const { default: Typography } = require('@mui/material/Typography');
const FieldGrid = require('hooks/useFormPrimitives/FieldGrid');
const FormField = require('./FormField');

const internals = {};

module.exports = function FieldGroup(props) {

    const {
        FieldComponent = FormField,
        componentRegistry,
        columns = 2,
        componentsByKey,
        componentsByName,
        componentsByType,
        description,
        fields,
        fieldNames = [],
        fieldProps = {},
        formId,
        genericComponentsByType,
        genericFieldAdapter,
        gap,
        rowGap,
        columnGap,
        singleRowMinHeight,
        title
    } = props;

    const visibleFields = fields || fieldNames.map((name) => ({ name }));

    return <internals.FieldGroupRoot>
        {title && (
            <Typography
                component='h2'
                variant='h6'
                gutterBottom
            >
                {title}
            </Typography>
        )}
        {description && (
            <Typography
                variant='body2'
                color='textSecondary'
                gutterBottom
            >
                {description}
            </Typography>
        )}
        <FieldGrid
            columns={columns}
            gap={gap}
            rowGap={rowGap}
            columnGap={columnGap}
            singleRowMinHeight={singleRowMinHeight}
        >
            {visibleFields.map((field) => (
                <FieldComponent
                    key={field.name}
                    columns={columns}
                    columnGap={columnGap}
                    componentRegistry={componentRegistry}
                    componentsByKey={componentsByKey}
                    componentsByName={componentsByName}
                    componentsByType={componentsByType}
                    formId={formId}
                    field={field}
                    fieldProps={fieldProps}
                    gap={gap}
                    genericComponentsByType={genericComponentsByType}
                    genericFieldAdapter={genericFieldAdapter}
                />
            ))}
        </FieldGrid>
    </internals.FieldGroupRoot>;
};

internals.FieldGroupRoot = Styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

module.exports.internals = internals;
